import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Components/Main/HomePage/Authentication/EmailVerification";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const EmailVerificationMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="EmailVerification">
      <MobileNotice page="EmailVerification" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default EmailVerificationMobile;